import { useEffect } from "react";

type PageMetaProps = {
  title: string;
  description: string;
  robots?: string;
};

function setMeta(
  attribute: "name" | "property",
  key: string,
  value: string,
) {
  const selector = `meta[${attribute}="${key}"]`;
  let element = document.head.querySelector<HTMLMetaElement>(selector);

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.append(element);
  }

  element.content = value;
}

export function PageMeta({ title, description, robots }: PageMetaProps) {
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    if (robots) {
      setMeta("name", "robots", robots);
    }
  }, [description, robots, title]);

  return null;
}
